/**
 * Shared Select-all helpers used by column filters
 * (DataTableNew value-array model + ColumnFilter status-item model).
 */

/** @param {Array<{ value: * }|*>} options */
export function toOptionValues(options = []) {
  return (options || []).map((opt) => (
    opt && typeof opt === 'object' && Object.prototype.hasOwnProperty.call(opt, 'value')
      ? opt.value
      : opt
  ));
}

/**
 * @param {Array} optionValues - visible option values
 * @param {Array} selectedValues - currently selected values
 */
export function areAllValuesSelected(optionValues = [], selectedValues = []) {
  if (!optionValues.length) return false;
  const selectedSet = new Set(selectedValues || []);
  return optionValues.every((value) => selectedSet.has(value));
}

/**
 * @param {Array} optionValues
 * @param {Array} selectedValues
 */
export function isValuesSelectAllIndeterminate(optionValues = [], selectedValues = []) {
  if (!optionValues.length) return false;
  const selectedSet = new Set(selectedValues || []);
  const selectedVisibleCount = optionValues.filter((value) => selectedSet.has(value)).length;
  return selectedVisibleCount > 0 && selectedVisibleCount < optionValues.length;
}

/**
 * Apply select-all to a value-array selection.
 * When searching, only `optionValues` (visible) are toggled; others are preserved.
 * @returns {Array} next selected values
 */
export function applySelectAllToValues(optionValues = [], selectedValues = [], checked = false) {
  const current = Array.isArray(selectedValues) ? [...selectedValues] : [];
  if (checked) {
    const selectedSet = new Set(current);
    optionValues.forEach((value) => {
      if (!selectedSet.has(value)) {
        selectedSet.add(value);
        current.push(value);
      }
    });
    return current;
  }
  const optionSet = new Set(optionValues);
  return current.filter((value) => !optionSet.has(value));
}

/**
 * Status-item model (ColumnFilter): items shaped like { value, status }.
 * @param {Array<{ status: boolean }>} items
 */
export function getStatusSelectAllState(items = []) {
  const list = items || [];
  if (!list.length) {
    return { checked: false, indeterminate: false };
  }
  const selectedCount = list.filter((item) => !!item.status).length;
  return {
    checked: selectedCount === list.length,
    indeterminate: selectedCount > 0 && selectedCount < list.length,
  };
}

/**
 * Toggle status on items (ColumnFilter select-all).
 * @param {Array<{ status: boolean }>} items
 * @param {boolean} checked
 * @param {(item: object) => void} [onItemToggled]
 */
export function applyStatusSelectAll(items = [], checked = false, onItemToggled) {
  (items || []).forEach((item) => {
    item.status = !!checked;
    if (typeof onItemToggled === 'function') onItemToggled(item);
  });
}
